import styled, { css } from 'styled-components';

export const StyledReviewDetail = styled.div`
  ${({ theme }) => css`
    border: ${theme.borderWidth} solid ${theme.color.surface.light};
    padding: ${theme.spacing.smMd};
  `}
`;
